import { memo } from "react";

function DailyPickupMarker(props) {
  const { borderColor= "white", size = 27 } = props;
  const backgroundColor = props.backgroundColor || props.color || "#E5A70D";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" fill={backgroundColor} />
      <path
        d="M5 5.675C5 5.30221 5.30221 5 5.675 5H18.675C19.0478 5 19.35 5.30221 19.35 5.675V10.675H18V6.35H6.35V18H10.675V19.35H5.675C5.30221 19.35 5 19.0478 5 18.675V5.675Z"
        fill={borderColor}
      />
      <path
        d="M15.158 13.0759C15.7593 12.9563 16.3835 13.0489 16.9242 13.3379C17.4649 13.6269 17.8887 14.0945 18.1233 14.6609C18.3579 15.2273 18.3889 15.8576 18.2109 16.4443C18.0329 17.0309 17.657 17.5378 17.1473 17.8784C16.6375 18.219 16.0254 18.3723 15.4153 18.3122C14.8051 18.2521 14.2347 17.9824 13.8012 17.5488C13.5376 17.2852 13.1102 17.2852 12.8466 17.5488C12.583 17.8124 12.583 18.2398 12.8466 18.5034C13.5009 19.1578 14.362 19.565 15.2829 19.6557C16.2039 19.7464 17.1278 19.515 17.8973 19.0009C18.6667 18.4867 19.2341 17.7217 19.5028 16.8361C19.7714 15.9506 19.7247 14.9992 19.3705 14.1443C19.0164 13.2893 18.3767 12.5836 17.5606 12.1473C16.7444 11.7111 15.8023 11.5713 14.8946 11.7519C13.987 11.9324 13.17 12.4221 12.583 13.1374C12.4999 13.2386 12.4222 13.3434 12.35 13.4514V12.675C12.35 12.3022 12.0478 12 11.675 12C11.3022 12 11 12.3022 11 12.675V15.675C11 15.854 11.0711 16.0257 11.1977 16.1523C11.3243 16.2789 11.496 16.35 11.675 16.35H12.3495C12.3496 16.35 12.3493 16.35 12.3495 16.35C12.3496 16.35 12.3504 16.35 12.3505 16.35L14.675 16.35C15.0478 16.35 15.35 16.0478 15.35 15.675C15.35 15.3022 15.0478 15 14.675 15H13.1124C13.2088 14.6341 13.3831 14.2904 13.6265 13.9939C14.0155 13.5199 14.5567 13.1955 15.158 13.0759Z"
        fill={borderColor}
      />
      <rect x="0.5" y="0.5" width="23" height="23" rx="1.5" stroke={borderColor} />
    </svg>
  );
}

export default memo(DailyPickupMarker);
